export enum ConsignmentStatus {
    AwaitingAcceptance = 2630,
    Accepted = 2631,
    Completed = 2632,
    Cancelled = 2633,
    Aborted = 2634,
    Rejected = 2635,
}
